var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fillRule: "evenodd",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.328,294H20.7a0.7,0.7,0,0,0-.7.688v5.5a0.7,0.7,0,0,0,.7.688h5.625a0.7,0.7,0,0,0,.7-0.688v-5.5A0.7,0.7,0,0,0,26.328,294Zm-0.7,5.5H21.406v-4.129h4.219v4.129Zm2.672-3.372a0.7,0.7,0,0,1,.7-0.688h8.3a0.688,0.688,0,1,1,0,1.376H29A0.7,0.7,0,0,1,28.3,296.133Zm9.7,2.615a0.7,0.7,0,0,1-.7.688H29a0.689,0.689,0,1,1,0-1.377h8.3A0.7,0.7,0,0,1,38,298.748Zm-11.672,3.371H20.7a0.7,0.7,0,0,0-.7.688v5.5a0.7,0.7,0,0,0,.7.688h5.625a0.7,0.7,0,0,0,.7-0.688v-5.5A0.7,0.7,0,0,0,26.328,302.119Zm-0.7,5.5H21.406V303.5h4.219v4.129ZM38,304.252a0.7,0.7,0,0,1-.7.688H29a0.688,0.688,0,1,1,0-1.376h8.3A0.7,0.7,0,0,1,38,304.252Zm0,2.615a0.7,0.7,0,0,1-.7.688H29a0.688,0.688,0,1,1,0-1.376h8.3A0.7,0.7,0,0,1,38,306.867Z",
    transform: "translate(-20 -294)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.e7c6c03d.svg";
export { ForwardRef as ReactComponent };